import { memo } from 'react'
import { Menu } from '@headlessui/react'
import { classNames } from '@app/utils/classes'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { GrLock } from 'react-icons/gr'
import { btnStyles, getMoreMenuStyle } from '../../cells/menu/styles'
import type { MoreOptionsProps } from '@app/types/website-more-options'
import { MenuList } from '../../menu'

// Base of more options ...
const MoreOptionsBaseComponentMock = ({
  //   pageUrl,
  url,
  index,
  children,
  handleMainClick,
  // events
  // handleClose,
  translation,
}: MoreOptionsProps) => {
  const { t } = useTranslation(translation || 'dashboard')

  //   const targetUrl = pageUrl || url
  //   const [href, reportHref, downloadLink] = useMemo(() => {
  //     const encodedUrl = targetUrl ? encodeURIComponent(targetUrl) : ''

  //     const link = targetUrl ? `/website-details?url=${encodedUrl}` : ''
  //     const report = targetUrl ? `/reports/${encodedUrl}` : ''
  //     const downloadL = targetUrl ? `/download-data-export?url=${encodedUrl}` : ''

  //     return [link, report, downloadL]
  //   }, [targetUrl])

  const menuId = `menu-appbar${index}`

  const account = {
    activeSubscription: true,
  }

  return (
    <MenuList id={menuId} more>
      <Menu.Item>
        {({ active }) => (
          <div className={getMoreMenuStyle(active, true)}>
            {`${t('view')} ${t('sandbox')}`}
          </div>
        )}
      </Menu.Item>
      <Menu.Item>
        {({ active }) => (
          <div className={getMoreMenuStyle(active, true)}>
            {`${t('view')} ${t('report')}`}
          </div>
        )}
      </Menu.Item>
      <Menu.Item>
        {({ active }) => (
          <button
            className={getMoreMenuStyle(active, account.activeSubscription)}
            type='button'
            disabled={!account.activeSubscription}
            onClick={handleMainClick(
              true,
              'Website Analytics',
              false,
              url as string
            )}
          >
            {t('view')} {t('analytics')}
            {!account.activeSubscription ? <GrLock className='grIcon' /> : null}
          </button>
        )}
      </Menu.Item>
      <Menu.Item>
        <div
          className={classNames(
            btnStyles,
            'flex place-items-center gap-x-2 pointer-events-none'
          )}
        >
          {t('export-data')}
        </div>
      </Menu.Item>
      {children}
    </MenuList>
  )
}

export const MoreOptionsBaseMock = memo(MoreOptionsBaseComponentMock)
